import { Route, Routes, useParams } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import { decodeApiKeyId } from "shared/ApiKey/urlHelpers";

import useGetApiKey from "./useGetApiKey";
import ApiKeyPageLayout from "./PageLayout";
import ApiKeyRoles from "./Roles";
import ApiKeyGroupMapping from "./GroupMapping";

const ApiKey = () => {
  const { apiKeyId } = useParams<{ apiKeyId: string }>();
  const decodedApiKeyId = apiKeyId ? decodeApiKeyId(apiKeyId) : undefined;
  const { apiKey, error, loading, refetch } = useGetApiKey({
    id: decodedApiKeyId,
  });

  if (loading && !apiKey) {
    return <PageLoading />;
  }

  if (!apiKey) {
    return <NotFoundPage />;
  }

  if (error) {
    return null;
  }

  return (
    <ApiKeyPageLayout apiKey={apiKey}>
      <Routes>
        <Route index element={<ApiKeyRoles apiKey={apiKey} refetch={refetch} />} />
        <Route path="group-mapping" element={<ApiKeyGroupMapping apiKey={apiKey} />} />
      </Routes>
    </ApiKeyPageLayout>
  );
};

export default ApiKey;
